import { useState, useEffect, useRef } from "react";
import ayushImg from "./assets/ayush.jpg";
import pawanImg from "./assets/pawan.jpg";
import prabhatImg from "./assets/prabhat.jpg";
import kapilImg from "./assets/kapil.jpg";
import teamBg from "./assets/bawadi-valley.jpg";
import amagarhBG from "./assets/amagarhbg.jpg";
import img1 from "./assets/img1.jpg";
import img2 from "./assets/img2.jpg";
import img3 from "./assets/img3.jpg";
import img4 from "./assets/img4.jpg";
import img5 from "./assets/img5.jpg";
import img6 from "./assets/img6.jpg";
import img7 from "./assets/img7.jpg";
import img8 from "./assets/img8.jpg";
import img9 from "./assets/img9.jpg";
import img10 from "./assets/img10.jpg";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ReactGA from "react-ga4";

ReactGA.initialize("G-XXXXXXXXXX");
ReactGA.send({
  hitType: "pageview",
  page: window.location.pathname,
});
const SITE_URL = "https://thetrektribes.in";
const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

const seoPages = [ 
  {
    slug: "trekking-in-jaipur",
    title: "Trekking in Jaipur | Best Weekend Treks in Aravalli Hills",
    heading: "Trekking in Jaipur",
    desc: "Explore trekking in Jaipur with The Trek Tribes. Join guided weekend treks, sunrise hikes and Aravalli Hills trails every Saturday and Sunday morning.",
    keywords: "trekking in jaipur, jaipur trekking, aravalli hills trek jaipur, weekend treks jaipur, hiking in jaipur",
    badge: "Jaipur Trekking Guide",
    intro: "Jaipur is known for forts, palaces and heritage streets, but the city also has a wild side hidden in the Aravalli Hills. The Trek Tribes helps people explore that side through guided, safe and community-driven weekend treks.",
    sections: [
      {
        h: "Why Jaipur is perfect for trekking",
        p: [
          "The Aravalli range around Jaipur offers rocky ridges, forest patches, old fort trails, sunrise points and peaceful valleys. These routes are close to the city, which makes them perfect for morning hikes and short weekend adventures.",
          "For beginners, Jaipur trekking is a simple way to start outdoor fitness. For regular hikers, the trails offer terrain, elevation, views and community energy."
        ]
      },
      {
        h: "Popular trekking experiences in Jaipur",
        p: [
          "The Trek Tribes organizes sunrise hikes, fort-view treks, Aravalli ridge walks, beginner-friendly nature trails and group hikes. Popular experiences include Amagarh Fort View, Bawadi Valley Hike, Twin Tower Trek and other scenic routes around Jaipur.",
          "Most treks are planned on Saturday and Sunday mornings so participants can enjoy nature without disturbing their weekly schedule."
        ]
      },
      {
        h: "Who can join these treks?",
        p: [
          "Our treks are suitable for beginners, students, working professionals, friend groups, families and outdoor lovers. Every trek is guided by experienced trek leaders who understand the local terrain.",
          "If you are new to trekking, choose an easy or moderate trail. If you already trek regularly, you can join challenging routes depending on the weekend plan."
        ]
      }
    ],
    faqs: [
      { q: "Is trekking in Jaipur suitable for beginners?", a: "Yes. Many Jaipur trails are beginner-friendly, especially morning hikes and easy Aravalli routes." },
      { q: "Which is the best time for trekking in Jaipur?", a: "Early morning is best. Winter and monsoon months are especially pleasant for Jaipur treks." },
      { q: "Do I need prior trekking experience?", a: "No. The Trek Tribes organizes guided treks for beginners as well as regular trekkers." },
      { q: "How can I book a trek in Jaipur?", a: "You can contact The Trek Tribes through the enquiry form or WhatsApp to join the next weekend trek." }
    ]
  },
  {
    slug: "weekend-treks-jaipur",
    title: "Weekend Treks in Jaipur | Saturday & Sunday Morning Treks",
    heading: "Weekend Treks in Jaipur",
    desc: "Join The Trek Tribes for Saturday and Sunday morning treks in Jaipur. Explore Aravalli Hills, sunrise points, nature trails and group hikes near Jaipur.",
    keywords: "weekend treks jaipur, saturday trek jaipur, sunday trek jaipur, morning trek jaipur, weekend hiking jaipur",
    badge: "Weekend Adventure",
    intro: "Weekend treks in Jaipur are perfect for people who want to escape the city routine, meet like-minded people and experience the Aravalli Hills without taking a full holiday.",
    sections: [
      {
        h: "Saturday and Sunday morning treks",
        p: [
          "The Trek Tribes organizes community treks mostly on Saturday and Sunday mornings. These treks usually begin early so participants can enjoy sunrise views, cool weather and peaceful trails.",
          "Morning treks are ideal for working professionals, students and groups who want a short adventure before the day begins."
        ]
      },
      {
        h: "What happens during a weekend trek?",
        p: [
          "A typical weekend trek includes reporting at the meeting point, a short briefing, guided trail walking, photo breaks, group interaction and return after completing the route.",
          "The focus is not only on walking but also on community, stories, views and safe outdoor exploration."
        ]
      },
      {
        h: "Why join The Trek Tribes?",
        p: [
          "The Trek Tribes is a Jaipur based trekking community. We focus on small groups, safer route planning, beginner-friendly guidance and memorable weekend experiences.",
          "Whether you are joining solo or with friends, the group energy makes every trek feel comfortable and exciting."
        ]
      }
    ],
    faqs: [
      { q: "Are weekend treks available every week?", a: "The Trek Tribes generally organizes treks on Saturday and Sunday mornings depending on route and weather." },
      { q: "Can I join alone?", a: "Yes. Many people join solo and become part of the trekking community." },
      { q: "What should I carry?", a: "Carry water, comfortable shoes, light snacks, sunscreen and a small backpack." },
      { q: "Are weekend treks safe?", a: "Yes. Routes are guided and planned with group safety in mind." }
    ]
  },
  {
    slug: "best-trekking-places-in-jaipur",
    title: "Best Trekking Places in Jaipur | Top Hiking Trails Near Jaipur",
    heading: "Best Trekking Places in Jaipur",
    desc: "Discover the best trekking places in Jaipur including Amagarh, Bawadi Valley, Nahargarh, Garh Ganesh, Twin Tower and Aravalli Hills trails.",
    keywords: "best trekking places in jaipur, hiking places in jaipur, best treks near jaipur, jaipur hiking trails",
    badge: "Top Trails",
    intro: "Jaipur has many trekking routes where you can experience sunrise views, rocky paths, forest trails, fort landscapes and peaceful valleys. These places are perfect for weekend hikers and beginners.",
    sections: [
      {
        h: "Top trekking routes around Jaipur",
        p: [
          "Some popular trekking places near Jaipur include Amagarh Fort View, Bawadi Valley Hike, Garh Ganesh Hill, Nahargarh Ridge, Twin Tower Trek and other Aravalli trails.",
          "Each trail has a different experience. Some are easy and scenic, while others offer a more challenging terrain."
        ]
      },
      {
        h: "Best trekking place for beginners",
        p: [
          "For beginners, Bawadi Valley Hike and easy Aravalli morning trails are good choices. These routes are shorter, scenic and comfortable for first-time trekkers.",
          "Beginners should always start with guided treks because local terrain can be confusing without route knowledge."
        ]
      },
      {
        h: "Best trekking place for views",
        p: [
          "Trails near Amagarh, Nahargarh and ridge areas offer some of the best views of Jaipur. Sunrise treks are especially popular because the city looks beautiful from the hills.",
          "The Trek Tribes selects routes based on weather, difficulty level, group size and safety."
        ]
      }
    ],
    faqs: [
      { q: "Which is the best trekking place in Jaipur?", a: "Amagarh, Bawadi Valley, Nahargarh and Garh Ganesh are popular options depending on your fitness level." },
      { q: "Are Jaipur trekking places beginner-friendly?", a: "Yes, many routes are beginner-friendly when done with a guided group." },
      { q: "Can I trek in Jaipur during summer?", a: "Early morning treks are possible, but winter and monsoon are more comfortable." },
      { q: "Do these places require permission?", a: "Some routes may have local rules. It is better to go with a local trekking group." }
    ]
  },
  {
    slug: "amagarh-fort-trek-jaipur",
    title: "Amagarh Fort Trek Jaipur | Guided Aravalli Trek Near Galta Ji",
    heading: "Amagarh Fort Trek Jaipur",
    desc: "Join Amagarh Fort Trek in Jaipur with The Trek Tribes. Explore Aravalli Hills, fort views, sunrise points and scenic trekking routes near Galta Ji.",
    keywords: "amagarh fort trek jaipur, amagarh trek, galta ji trek jaipur, aravalli trek jaipur",
    badge: "Fort View Trek",
    intro: "Amagarh Fort Trek is one of the most scenic trekking experiences in Jaipur. The route gives you a mix of rocky paths, Aravalli views, heritage feel and peaceful morning landscapes.",
    sections: [
      {
        h: "About Amagarh Fort Trek",
        p: [
          "Located near Galta Ji, the Amagarh side of Jaipur is known for its hill views and rugged terrain. It is a good trail for people who want a proper trekking feel without going far from the city.",
          "The trek is suitable for beginners with basic fitness and also enjoyable for regular hikers."
        ]
      },
      {
        h: "What makes this trek special?",
        p: [
          "The trail offers city views, sunrise moments, natural rock formations and a fort-side experience. It is a great route for photography, fitness and weekend adventure.",
          "With a guided group, the trek becomes safer and more enjoyable because the route and pace are managed properly."
        ]
      },
      {
        h: "Book Amagarh Trek with The Trek Tribes",
        p: [
          "The Trek Tribes organizes guided Amagarh Fort View treks for individuals and groups. You can join solo, with friends or as a small private group.",
          "Our focus is safety, community, scenic trails and a memorable outdoor experience in Jaipur."
        ]
      }
    ],
    faqs: [
      { q: "Is Amagarh Fort Trek difficult?", a: "It is generally moderate and suitable for beginners with basic fitness." },
      { q: "Where is Amagarh Fort Trek located?", a: "It is near Galta Ji area in Jaipur." },
      { q: "How long is the Amagarh trek?", a: "The duration depends on the route plan, but it is usually a morning trek." },
      { q: "Can beginners join Amagarh Trek?", a: "Yes, beginners can join with a guided group." }
    ]
  },
  {
    slug: "bawadi-valley-trek-jaipur",
    title: "Bawadi Valley Trek Jaipur | Beginner Friendly Morning Hike",
    heading: "Bawadi Valley Trek Jaipur",
    desc: "Experience Bawadi Valley Trek in Jaipur with The Trek Tribes. A beginner-friendly morning hike with scenic Aravalli landscapes and group adventure.",
    keywords: "bawadi valley trek jaipur, bawadi valley hike, jaipur morning hike, beginner trek jaipur",
    badge: "Beginner Friendly",
    intro: "Bawadi Valley Trek is a peaceful and beginner-friendly hiking experience near Jaipur. It is ideal for people who want nature, fresh air, group energy and a light outdoor adventure.",
    sections: [
      {
        h: "About Bawadi Valley Hike",
        p: [
          "Bawadi Valley is known for its calm surroundings, natural terrain and scenic morning atmosphere. It is one of the comfortable options for people starting their trekking journey.",
          "The route is suitable for beginners, friend groups and people looking for a weekend fitness activity."
        ]
      },
      {
        h: "Why choose Bawadi Valley Trek?",
        p: [
          "This trek offers a balanced experience of nature, walking, views and community. It does not feel too difficult, which makes it ideal for first-time trekkers.",
          "Morning timing makes the route more enjoyable because the weather is cooler and the light is perfect for photography."
        ]
      },
      {
        h: "Join Bawadi Valley Trek",
        p: [
          "The Trek Tribes organizes guided Bawadi Valley hikes for solo participants, friend groups and beginners.",
          "If you want to start trekking in Jaipur, this is one of the best routes to begin with."
        ]
      }
    ],
    faqs: [
      { q: "Is Bawadi Valley Trek good for beginners?", a: "Yes. It is one of the beginner-friendly trekking options near Jaipur." },
      { q: "What should I carry for Bawadi Valley Trek?", a: "Carry water, trekking shoes, light snacks and a small backpack." },
      { q: "Can I join this trek solo?", a: "Yes. Solo participants can join The Trek Tribes group treks." },
      { q: "Is it a morning trek?", a: "Yes, it is usually planned as a morning hike." }
    ]
  },
  {
    slug: "sunrise-trek-jaipur",
    title: "Sunrise Trek Jaipur | Morning Treks in Aravalli Hills",
    heading: "Sunrise Trek Jaipur",
    desc: "Join sunrise treks in Jaipur with The Trek Tribes. Explore Aravalli Hills, morning hikes and scenic trails with a guided trekking community.",
    keywords: "sunrise trek jaipur, morning trek jaipur, sunrise hike jaipur, aravalli sunrise trek",
    badge: "Sunrise Hikes",
    intro: "Sunrise treks in Jaipur are perfect for people who love early mornings, golden views and peaceful trails. The city looks completely different from the Aravalli ridges during sunrise.",
    sections: [
      {
        h: "Why sunrise treks are popular in Jaipur",
        p: [
          "The early morning weather is cooler, the trails are quieter and the views are beautiful. Sunrise treks give you a fresh start before the city becomes busy.",
          "The Trek Tribes plans sunrise hikes on selected routes around Jaipur depending on weather and group suitability."
        ]
      },
      {
        h: "Best experience for fitness and photography",
        p: [
          "Sunrise hikes are great for fitness, photography and mental refreshment. Many participants join for nature, community and a break from screen-heavy routines.",
          "The golden light, fort views and Aravalli landscape make these treks memorable."
        ]
      }
    ],
    faqs: [
      { q: "What time does a sunrise trek start?", a: "Sunrise treks usually start early morning before sunrise depending on season." },
      { q: "Are sunrise treks safe?", a: "Yes, when planned with a guided group and proper route knowledge." },
      { q: "Can beginners join sunrise treks?", a: "Yes, beginners can join easy sunrise routes." },
      { q: "What should I wear?", a: "Wear comfortable trekking shoes and breathable clothes." }
    ]
  },
  {
  slug: "treks",
  title: "Treks | Guided Weekend Treks in Jaipur",
  heading: "Treks",
  desc: "Explore guided treks in Jaipur with The Trek Tribes. Join safe, beginner-friendly and scenic weekend treks in the Aravalli Hills.",
  keywords: "treks, treks in jaipur, jaipur treks, weekend treks, aravalli treks",
  badge: "Guided Treks",
  intro: "The Trek Tribes organizes guided treks for beginners, solo travellers, friend groups and adventure lovers who want to explore Jaipur beyond forts and city streets.",
  sections: [
    {
      h: "Guided treks for every level",
      p: [
        "Our treks are designed for beginners as well as regular outdoor explorers. Every route is selected based on safety, views, group size and weather.",
        "Popular experiences include sunrise treks, fort-view trails, valley hikes and Aravalli ridge walks."
      ]
    },
    {
      h: "Why join The Trek Tribes?",
      p: [
        "You get route guidance, group support, safety briefing, scenic photo points and a community experience.",
        "Whether you are joining alone or with friends, our weekend treks make outdoor adventure simple and enjoyable."
      ]
    }
  ],
  faqs: [
    { q: "Are your treks beginner-friendly?", a: "Yes, many of our treks are suitable for beginners with basic fitness." },
    { q: "Do I need trekking experience?", a: "No, you can join beginner-friendly routes without prior experience." },
    { q: "Where do you organize treks?", a: "Most treks are organized around Jaipur and the Aravalli Hills." },
    { q: "How can I book a trek?", a: "You can submit the enquiry form or contact The Trek Tribes directly." }
  ]
},
{
  slug: "trek-in-jaipur",
  title: "Trek in Jaipur | Best Guided Treks Near Jaipur",
  heading: "Trek in Jaipur",
  desc: "Looking for a trek in Jaipur? Join The Trek Tribes for guided sunrise treks, weekend hikes and Aravalli Hill adventures near Jaipur.",
  keywords: "trek in jaipur, jaipur trek, guided trek jaipur, sunrise trek jaipur, aravalli trek",
  badge: "Jaipur Trek",
  intro: "A trek in Jaipur is one of the best ways to experience the natural side of the Pink City. The Aravalli Hills offer scenic trails, sunrise points, rocky paths and peaceful valleys.",
  sections: [
    {
      h: "Best way to start trekking in Jaipur",
      p: [
        "If you are new to trekking, Jaipur has many beginner-friendly routes where you can start safely with a guided group.",
        "The Trek Tribes helps participants enjoy nature, fitness, photography and group adventure in one experience."
      ]
    },
    {
      h: "What to expect on a Jaipur trek",
      p: [
        "A typical trek includes reporting at the meeting point, group briefing, guided trail walk, photo breaks and return after completing the route.",
        "Most treks are planned early morning so participants can enjoy cool weather and sunrise views."
      ]
    }
  ],
  faqs: [
    { q: "Which is the best trek in Jaipur?", a: "Amagarh, Bawadi Valley, Nahargarh side trails and Garh Ganesh routes are popular options." },
    { q: "Can beginners join a trek in Jaipur?", a: "Yes, beginners can join guided easy and moderate treks." },
    { q: "What should I carry?", a: "Carry water, comfortable shoes, light snacks and a small backpack." },
    { q: "Are Jaipur treks safe?", a: "Yes, guided group treks are planned with safety and route knowledge." }
  ]
},
{
  slug: "best-mountain-biking-trails",
  title: "Best Mountain Biking Trails in Jaipur | Aravalli Adventure Routes",
  heading: "Best Mountain Biking Trails",
  desc: "Discover the best mountain biking trails near Jaipur with scenic Aravalli routes, rocky paths, nature tracks and adventure-friendly outdoor experiences.",
  keywords: "best mountain biking trails, mountain biking jaipur, cycling trails jaipur, aravalli biking trails, adventure trails jaipur",
  badge: "Mountain Biking",
  intro: "Jaipur and the Aravalli belt offer exciting outdoor routes for people who love cycling, trails and adventure. Mountain biking trails around Jaipur combine rocky terrain, scenic views and fitness.",
  sections: [
    {
      h: "Why Jaipur is good for mountain biking",
      p: [
        "The Aravalli region around Jaipur has natural slopes, off-road patches, rocky tracks and scenic morning routes that make it suitable for adventure biking.",
        "Many trekking routes and hill-side paths can also inspire mountain biking experiences depending on access, weather and safety."
      ]
    },
    {
      h: "Safety first on biking trails",
      p: [
        "Mountain biking should always be done with helmet, gloves, proper brakes, hydration and route awareness.",
        "Beginners should start with easier trails before trying steep, rocky or technical routes."
      ]
    }
  ],
  faqs: [
    { q: "Are there mountain biking trails near Jaipur?", a: "Yes, Jaipur has several outdoor and Aravalli-side routes suitable for trail cycling and adventure biking." },
    { q: "Can beginners try mountain biking?", a: "Beginners should start with easy routes and proper safety gear." },
    { q: "What gear is required?", a: "Helmet, gloves, proper shoes, water bottle and a well-serviced cycle are recommended." },
    { q: "Does The Trek Tribes organize biking trails?", a: "You can contact The Trek Tribes through the enquiry form for available outdoor adventure plans." }
  ]
}
];

/* ─── GOOGLE FONTS ─── */
const FontLoader = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700&family=Syne:wght@400;600;700;800&family=Crimson+Text:ital,wght@0,400;1,400&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }, []);
  return null;
};
const SEO = ({ pageData = null }) => {
  const isArticle = Boolean(pageData);
  const title = isArticle
    ? pageData.title
    : "The Trek Tribes | Weekend Treks in Jaipur & Aravalli Hills";

  const description = isArticle
    ? pageData.desc
    : "The Trek Tribes is a Jaipur based trekking community organizing guided Saturday and Sunday morning treks in the Aravalli Hills of Jaipur.";

  const canonical = isArticle
    ? `${SITE_URL}/${pageData.slug}`
    : `${SITE_URL}/`;

  const keywords = isArticle
    ? pageData.keywords
    : "The Trek Tribes, trekking in Jaipur, Jaipur trekking community, weekend treks Jaipur, Aravalli Hills trek Jaipur, Saturday trek Jaipur, Sunday trek Jaipur, morning trek Jaipur";

  const businessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "The Trek Tribes",
    description,
    url: SITE_URL,
    telephone: "+91 94614 41052",
    email: "tribestrek@gmail.com",
    image: OG_IMAGE,
    address: {
      "@type": "PostalAddress",
      streetAddress: "Ramnagar Extension, Sodala",
      addressLocality: "Jaipur",
      addressRegion: "Rajasthan",
      postalCode: "302019",
      addressCountry: "IN"
    },
    areaServed: "Jaipur, Rajasthan",
    openingHours: ["Mo-Fr 07:00-19:00", "Sa 05:00-20:00", "Su 04:00-21:00"],
    sameAs: ["https://www.instagram.com/trek_tribes_"]
  };

  const articleSchema = pageData
    ? {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: pageData.heading,
        description: pageData.desc,
        image: OG_IMAGE,
        author: {
          "@type": "Organization",
          name: "The Trek Tribes"
        },
        publisher: {
          "@type": "Organization",
          name: "The Trek Tribes",
          logo: {
            "@type": "ImageObject",
            url: `${SITE_URL}/logo192.png`
          }
        },
        mainEntityOfPage: canonical
      }
    : null;

  const faqSchema = pageData
    ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: pageData.faqs.map(item => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.a
          }
        }))
      }
    : null;

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={isArticle ? "article" : "website"} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="The Trek Tribes" />
      <meta property="og:image" content={OG_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      <script type="application/ld+json">
        {JSON.stringify(isArticle ? articleSchema : businessSchema)}
      </script>

      {faqSchema && (
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      )}
    </Helmet>
  );
};
/* ─── GLOBAL STYLES ─── */
const GlobalStyles = () => {
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
      :root {
        --sand:#F2E8D5; --ochre:#C9883A; --rust:#A0432F;
        --pine:#2D4A3E; --dusk:#1A2B24; --cream:#FAF6EE;
        --stone:#8A7968; --white:#FFFFFF;
      }
      html { scroll-behavior: smooth; }
      body { background:var(--cream); color:var(--dusk); font-family:'Syne',sans-serif; overflow-x:hidden; cursor:none; }
      * { cursor:none !important; }
      @keyframes slowzoom { from{transform:scale(1.05)} to{transform:scale(1.13)} }
      @keyframes fadeUp   { from{opacity:0;transform:translateY(32px)} to{opacity:1;transform:translateY(0)} }
      @keyframes fadeIn   { from{opacity:0} to{opacity:1} }
      @keyframes scrollDrop { 0%,100%{opacity:1;transform:scaleY(1)} 50%{opacity:.3;transform:scaleY(.4)} }
      @keyframes float    { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-12px)} }
      @keyframes cardIn   { from{opacity:0;transform:translateY(50px) scale(.97)} to{opacity:1;transform:translateY(0) scale(1)} }
      @keyframes linegrow { from{width:0} to{width:60px} }
      input,select,textarea { cursor:none !important; }
      input:focus,select:focus,textarea:focus { outline:none; }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);
  return null;
};

/* ─── CUSTOM CURSOR ─── */
const Cursor = () => {
  const dot  = useRef(null);
  const ring = useRef(null);
  const pos  = useRef({ x:0, y:0 });
  const rPos = useRef({ x:0, y:0 });
  useEffect(() => {
    const move = e => { pos.current = { x:e.clientX, y:e.clientY }; };
    window.addEventListener("mousemove", move);
    let raf;
    const tick = () => {
      rPos.current.x += (pos.current.x - rPos.current.x) * 0.12;
      rPos.current.y += (pos.current.y - rPos.current.y) * 0.12;
      if (dot.current)  dot.current.style.transform  = `translate(${pos.current.x-5}px,${pos.current.y-5}px)`;
      if (ring.current) ring.current.style.transform = `translate(${rPos.current.x-18}px,${rPos.current.y-18}px)`;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => { window.removeEventListener("mousemove", move); cancelAnimationFrame(raf); };
  }, []);
  return (
    <>
      <div ref={dot}  style={{position:"fixed",top:0,left:0,width:10,height:10,background:"var(--ochre)",borderRadius:"50%",pointerEvents:"none",zIndex:9999}} />
      <div ref={ring} style={{position:"fixed",top:0,left:0,width:36,height:36,border:"1.5px solid var(--ochre)",borderRadius:"50%",pointerEvents:"none",zIndex:9998,opacity:.55}} />
    </>
  );
};

/* ─── REVEAL HOOK ─── */
const useReveal = () => {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVis(true); obs.unobserve(el); } }, { threshold:0.1 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return [ref, vis];
};

const Reveal = ({ children, delay=0, style={} }) => {
  const [ref, vis] = useReveal();
  return (
    <div ref={ref} style={{ opacity:vis?1:0, transform:vis?"translateY(0)":"translateY(40px)", transition:`opacity .85s ease ${delay}s, transform .85s ease ${delay}s`, ...style }}>
      {children}
    </div>
  );
};

/* ─── NAV ─── */
const Nav = ({ page, setPage }) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  const links = ["Home","Treks","Gallery","Experiences","Team","Contact"];
  const solidPages = ["contact","team"];

  return (
    <nav style={{
      position:"fixed",top:0,left:0,right:0,zIndex:200,
      display:"flex",alignItems:"center",justifyContent:"space-between",
      padding: scrolled || solidPages.includes(page) ? "1rem 3rem" : "1.6rem 3rem",
      background: scrolled || solidPages.includes(page) ? "rgba(26,43,36,0.97)" : "transparent",
      backdropFilter: scrolled || solidPages.includes(page) ? "blur(14px)" : "none",
      transition:"all .4s ease",
      borderBottom: scrolled || solidPages.includes(page) ? "1px solid rgba(255,255,255,0.07)" : "none"
    }}>
      <button onClick={() => { setPage("home"); window.scrollTo(0,0); }}
        style={{background:"none",border:"none",fontFamily:"'Playfair Display',serif",fontSize:"1.45rem",fontWeight:900,color:"var(--white)",letterSpacing:".02em"}}>
        The Trek<span style={{color:"var(--ochre)"}}>Tribes</span>
      </button>

      <ul style={{display:"flex",gap:"2.2rem",listStyle:"none"}}>
        {links.map(l => {
          const isActive = (l==="Contact"&&page==="contact")||(l==="Team"&&page==="team")||(l==="Home"&&page==="home");
          return (
            <li key={l}>
              <button onClick={() => {
                if (l==="Contact") { setPage("contact"); window.scrollTo(0,0); }
                else if (l==="Team")    { setPage("team");    window.scrollTo(0,0); }
                else if (l==="Home")   { setPage("home");    window.scrollTo(0,0); }
                else { setPage("home"); setTimeout(() => { const el = document.getElementById(l.toLowerCase()); if(el) el.scrollIntoView({behavior:"smooth"}); }, 100); }
              }} style={{
                background:"none",border:"none",
                color: isActive ? "var(--ochre)" : "rgba(255,255,255,.8)",
                fontSize:".78rem",letterSpacing:".15em",textTransform:"uppercase",fontWeight:700,
                fontFamily:"'Syne',sans-serif",transition:"color .3s",
                borderBottom: isActive ? "1.5px solid var(--ochre)" : "1.5px solid transparent",
                paddingBottom:"2px"
              }}>{l}</button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

/* ══════════════════════════════════════════
   HOME PAGE
══════════════════════════════════════════ */

const Hero = ({ setPage }) => (
  <section style={{height:"100vh",position:"relative",overflow:"hidden",display:"flex",alignItems:"flex-end",padding:"5rem 4rem"}}>
    <div
  style={{
    position: "absolute",
    inset: 0,
    backgroundImage: `url(${teamBg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    animation: "slowzoom 20s ease-in-out infinite alternate",
  }}
/>
    <div style={{position:"absolute",inset:0,background:"linear-gradient(160deg,rgba(26,43,36,.72) 0%,rgba(160,67,47,.18) 55%,rgba(26,43,36,.85) 100%)"}} />
    <div style={{position:"absolute",inset:0,opacity:.28,backgroundImage:`url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.07'/%3E%3C/svg%3E")`}} />
    <div style={{position:"relative",zIndex:2,maxWidth:820}}>
      <span style={{display:"inline-block",background:"var(--ochre)",color:"var(--white)",fontSize:".68rem",letterSpacing:".25em",textTransform:"uppercase",padding:".4rem 1rem",marginBottom:"1.5rem",fontWeight:700,animation:"fadeIn 1s ease .2s both"}}>
        Jaipur · Rajasthan · Aravalli Hills
      </span>
      {/* <h5 style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(3.5rem,8vw,7.2rem)",fontWeight:900,color:"var(--white)",lineHeight:1.0,marginBottom:"1.4rem",animation:"fadeUp 1s ease .35s both"}}>
        Wander into the <em style={{color:"var(--ochre)",fontStyle:"italic"}}>Wild</em><br/>Heart of Jaipur
      </h5> */}
      <p style={{fontFamily:"'Crimson Text',serif",fontSize:"1.25rem",color:"rgba(255,255,255,.78)",maxWidth:500,lineHeight:1.75,marginBottom:"2.5rem",animation:"fadeUp 1s ease .5s both"}}>
        Ancient trails, monsoon forests, and golden horizons — we guide tribes of adventurers through Rajasthan's most breathtaking terrains.
      </p>
      <div style={{display:"flex",gap:"1rem",flexWrap:"wrap",animation:"fadeUp 1s ease .65s both"}}>
        <button onClick={() => { const el=document.getElementById("treks"); if(el) el.scrollIntoView({behavior:"smooth"}); }}
          style={{background:"var(--ochre)",color:"var(--white)",padding:".9rem 2.2rem",border:"none",fontFamily:"'Syne',sans-serif",fontSize:".8rem",letterSpacing:".12em",textTransform:"uppercase",fontWeight:700}}
          onMouseEnter={e=>{e.currentTarget.style.background="var(--rust)";e.currentTarget.style.transform="translateY(-2px)"}}
          onMouseLeave={e=>{e.currentTarget.style.background="var(--ochre)";e.currentTarget.style.transform="translateY(0)"}}>
          Explore Treks
        </button>
        <button onClick={()=>setPage("contact")}
          style={{border:"1.5px solid rgba(255,255,255,.55)",color:"var(--white)",padding:".9rem 2.2rem",background:"transparent",fontFamily:"'Syne',sans-serif",fontSize:".8rem",letterSpacing:".12em",textTransform:"uppercase",fontWeight:700}}
          onMouseEnter={e=>{e.currentTarget.style.borderColor="var(--ochre)";e.currentTarget.style.color="var(--ochre)"}}
          onMouseLeave={e=>{e.currentTarget.style.borderColor="rgba(255,255,255,.55)";e.currentTarget.style.color="var(--white)"}}>
          Join a Tribe
        </button>
      </div>
    </div>
    <div style={{position:"absolute",bottom:"2.5rem",right:"4rem",zIndex:2,display:"flex",flexDirection:"column",alignItems:"center",gap:".5rem",animation:"fadeIn 1.5s ease 1.2s both"}}>
      <span style={{fontSize:".62rem",letterSpacing:".2em",textTransform:"uppercase",color:"rgba(255,255,255,.45)",writingMode:"vertical-rl"}}>Scroll</span>
      <div style={{width:1,height:60,background:"linear-gradient(to bottom,var(--ochre),transparent)",animation:"scrollDrop 2s ease-in-out infinite"}} />
    </div>
  </section>
);

const Stats = () => {
  const items = [["2400+","Trekkers Guided"],["18","Unique Trails"],["7 Yrs","Experience"],["100%","Safe Returns"]];
  return (
    <div style={{background:"var(--pine)",display:"flex",justifyContent:"center",flexWrap:"wrap"}}>
      {items.map(([n,l],i) => (
        <Reveal key={i} delay={i*.08} style={{flex:"1 1 200px",padding:"2rem 3rem",textAlign:"center",borderRight:i<3?"1px solid rgba(255,255,255,.1)":"none"}}>
          <span style={{fontFamily:"'Playfair Display',serif",fontSize:"2.4rem",fontWeight:900,color:"var(--ochre)",display:"block"}}>{n}</span>
          <span style={{fontSize:".68rem",letterSpacing:".18em",textTransform:"uppercase",color:"rgba(255,255,255,.5)",marginTop:".3rem",display:"block"}}>{l}</span>
        </Reveal>
      ))}
    </div>
  );
};

const About = ({ setPage }) => (
  <section style={{display:"grid",gridTemplateColumns:"1fr 1fr",minHeight:"75vh"}}>
    <div style={{position:"relative",overflow:"hidden"}}>
      <img src={amagarhBG} alt="Trekkers"
        style={{width:"100%",height:"100%",objectFit:"cover",transition:"transform 6s ease",display:"block"}}
        onMouseEnter={e=>e.target.style.transform="scale(1.05)"}
        onMouseLeave={e=>e.target.style.transform="scale(1)"} />
      <div style={{position:"absolute",bottom:"2.5rem",left:"2.5rem",background:"var(--ochre)",color:"var(--white)",padding:"1.2rem 1.8rem"}}>
        <strong style={{fontFamily:"'Playfair Display',serif",fontSize:"2.2rem",fontWeight:900,display:"block",lineHeight:1}}>Est.</strong>
        <strong style={{fontFamily:"'Playfair Display',serif",fontSize:"2.2rem",fontWeight:900,display:"block",lineHeight:1}}>2025</strong>
        <span style={{fontSize:".68rem",letterSpacing:".15em",textTransform:"uppercase"}}>More Than Treks, It's a Tribe</span>
      </div>
    </div>
    <div style={{background:"var(--sand)",padding:"5rem"}}>
      <Reveal>
        <p style={{fontSize:".68rem",letterSpacing:".25em",textTransform:"uppercase",color:"var(--ochre)",fontWeight:700,marginBottom:".8rem"}}>About Us</p>
        <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(2rem,3.5vw,3rem)",fontWeight:900,lineHeight:1.1,color:"var(--dusk)",marginBottom:"1.5rem"}}>
          Born from the <em style={{fontStyle:"italic",color:"var(--rust)"}}>dust</em> of Rajasthan's trails
        </h2>
        <p style={{fontFamily:"'Crimson Text',serif",fontSize:"1.1rem",lineHeight:1.8,color:"var(--stone)",marginBottom:"1rem"}}>
          The Trek Tribes was founded by a group of passionate wanderers who believed Jaipur is far more than its palaces. Hidden in the Aravalli folds are ancient trading routes, monsoon-kissed forests, and ridgelines with views that stop time.
        </p>
        <p style={{fontFamily:"'Crimson Text',serif",fontSize:"1.1rem",lineHeight:1.8,color:"var(--stone)",marginBottom:"2.5rem"}}>
          We lead small, intimate groups — never more than 12 people — ensuring every trekker gets personal guidance, cultural stories, and memories worth carrying home.
        </p>
        <div style={{display:"flex",flexWrap:"wrap",gap:"1.5rem"}}>
          {["Certified Guides","Small Groups","Eco-Responsible","All Levels Welcome"].map(f => (
            <span key={f} style={{display:"flex",alignItems:"center",gap:".6rem",fontSize:".75rem",letterSpacing:".08em",textTransform:"uppercase",fontWeight:700,color:"var(--pine)"}}>
              <span style={{width:24,height:2,background:"var(--ochre)",display:"inline-block",flexShrink:0}} />{f}
            </span>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

// const treks = [
//   {img:"https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=900&q=80",diff:"Moderate",diffColor:"var(--ochre)",name:"Nahargarh Ridge Sunrise Trek",loc:"Nahargarh Fort",time:"4 hrs",dist:"9 km",big:true},
//   {img:"https://images.unsplash.com/photo-1458442310124-dde6edb43d10?w=600&q=80",diff:"Easy",diffColor:"#4CAF50",name:"Monsoon Forest Walk",loc:"Jhalana Reserve",time:"2.5 hrs"},
//   {img:"https://images.unsplash.com/photo-1501854140801-50d01698950b?w=600&q=80",diff:"Challenging",diffColor:"var(--rust)",name:"Aravalli Moonlit Night Trek",loc:"Amer Hills",time:"6 hrs"},
//   {img:"https://images.unsplash.com/photo-1559521783-1d1599583485?w=600&q=80",diff:"Moderate",diffColor:"var(--ochre)",name:"Fort to Fort Heritage Trail",loc:"Amer to Nahargarh",time:"5 hrs"},
//   {img:"https://images.unsplash.com/photo-1519681393784-d120267933ba?w=600&q=80",diff:"Easy",diffColor:"#4CAF50",name:"Hilltop Stargazing Retreat",loc:"Jaipur Outskirts",time:"3 hrs"},
// ];
const treks = [
  {
    img: img1,
    diff: "Moderate",
    diffColor: "var(--ochre)",
    name: "Amagarh Fort View",
    loc: "Near Galta Ji",
    time: "4 hrs",
    dist: "5 km",
    big: true
  },
  {
    img: img2,
    diff: "Hard",
    diffColor: "#f73c3c",
    name: "Bann Ki Ghati",
    loc: "Delhi-Ajmer Highway",
    time: "5 hrs"
  },
  {
    img: img3,
    diff: "Challenging",
    diffColor: "var(--rust)",
    name: "Chabootara Trek",
    loc: "Garh Ganesh Hill",
    time: "3 hrs"
  },
  {
    img: img4,
    diff: "Moderate",
    diffColor: "var(--ochre)",
    name: "Twin Tower Trek",
    loc: "Near Galta Ji",
    time: "3 hrs"
  },
  {
    img: img5,
    diff: "Easy",
    diffColor: "#4CAF50",
    name: "Bawadi Valley Hike",
    loc: "Jaipur Outskirts",
    time: "3 hrs"
   }
  // {
  //   img: img6,
  //   diff: "Moderate",
  //   diffColor: "var(--ochre)",
  //   name: "Adventure Trek 6",
  //   loc: "Jaipur",
  //   time: "4 hrs"
  // },
  // {
  //   img: img7,
  //   diff: "Easy",
  //   diffColor: "#4CAF50",
  //   name: "Adventure Trek 7",
  //   loc: "Jaipur",
  //   time: "3 hrs"
  // },
  // {
  //   img: img8,
  //   diff: "Moderate",
  //   diffColor: "var(--ochre)",
  //   name: "Nindar Fort Hike",
  //   loc: "Jaipur",
  //   time: "3 hrs"
  // },
  // {
  //   img: img9,
  //   diff: "Challenging",
  //   diffColor: "var(--rust)",
  //   name: "Adventure Trek 9",
  //   loc: "Jaipur",
  //   time: "6 hrs"
  // },
  // {
  //   img: img10,
  //   diff: "Easy",
  //   diffColor: "#4CAF50",
  //   name: "Adventure Trek 10",
  //   loc: "Jaipur",
  //   time: "2 hrs"
  // }
];

const TrekCard = ({ img, diff, diffColor, name, loc, time, dist, big, i }) => {
  const [hov, setHov] = useState(false);
  const [ref, vis] = useReveal();
  return (
    <div ref={ref} onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{gridColumn:big?"1/3":"auto",position:"relative",overflow:"hidden",
        opacity:vis?1:0,transform:vis?"translateY(0)":"translateY(40px)",
        transition:`opacity .8s ease ${i*.1}s, transform .8s ease ${i*.1}s`}}>
      <img src={img} alt={name} style={{width:"100%",height:big?420:280,objectFit:"cover",display:"block",transition:"transform .7s ease",transform:hov?"scale(1.07)":"scale(1)"}} />
      <div style={{position:"absolute",inset:0,background:"linear-gradient(to top,rgba(26,43,36,.93) 0%,transparent 55%)",display:"flex",flexDirection:"column",justifyContent:"flex-end",padding:"1.8rem"}}>
        <span style={{display:"inline-block",background:diffColor,color:"var(--white)",fontSize:".6rem",letterSpacing:".2em",textTransform:"uppercase",fontWeight:700,padding:".3rem .8rem",marginBottom:".8rem",width:"fit-content"}}>{diff}</span>
        <div style={{fontFamily:"'Playfair Display',serif",fontSize:big?"2rem":"1.35rem",fontWeight:700,color:"var(--white)",lineHeight:1.2}}>{name}</div>
        <div style={{display:"flex",gap:"1.2rem",marginTop:".5rem"}}>
          <span style={{fontSize:".7rem",letterSpacing:".08em",textTransform:"uppercase",color:"rgba(255,255,255,.6)"}}>📍 {loc}</span>
          <span style={{fontSize:".7rem",letterSpacing:".08em",textTransform:"uppercase",color:"rgba(255,255,255,.6)"}}>⏱ {time}</span>
          {dist && <span style={{fontSize:".7rem",color:"rgba(255,255,255,.6)"}}>📏 {dist}</span>}
        </div>
      </div>
    </div>
  );
};

const Treks = ({ setPage }) => (
  <section id="treks" style={{padding:"6rem 4rem",background:"var(--cream)"}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:"3.5rem"}}>
      <Reveal>
        <p style={{fontSize:".68rem",letterSpacing:".25em",textTransform:"uppercase",color:"var(--ochre)",fontWeight:700,marginBottom:".8rem"}}>Our Trails</p>
        <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(2rem,4vw,3.2rem)",fontWeight:900,lineHeight:1.1,color:"var(--dusk)"}}>
          Choose your <em style={{fontStyle:"italic",color:"var(--rust)"}}>adventure</em>
        </h2>
      </Reveal>
      <Reveal>
        <button onClick={()=>setPage("contact")} style={{background:"var(--ochre)",color:"var(--white)",padding:".9rem 2.2rem",border:"none",fontFamily:"'Syne',sans-serif",fontSize:".78rem",letterSpacing:".12em",textTransform:"uppercase",fontWeight:700}}>Book a Trek</button>
      </Reveal>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"1.2rem"}}>
      {treks.map((t,i) => <TrekCard key={i} {...t} i={i} />)}
    </div>
  </section>
);

const galleryItems = [
  {img:img10,label:"Nahargarh Ridge",span:"2/2"},
  {img:img1,label:"Aravalli Sunrise"},
  {img:img8,label:"Forest Path"},
  {img:img2,label:"Desert Landscape",spanCol:"2"},
  {img:img6,label:"Milky Way Trek"},
  {img:img5,label:"Rocky Terrain",span:"2/2"},
  {img:img4,label:"Monsoon Walk"},
  {img:img3,label:"Wildlife Spotting"},
];

const GalleryItem = ({ img, label, span, spanCol, i }) => {
  const [hov, setHov] = useState(false);
  const [ref, vis] = useReveal();
  return (
    <div ref={ref} onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{gridColumn:spanCol==="2"?"span 2":"auto",gridRow:span==="2/2"?"span 2":"auto",
        position:"relative",overflow:"hidden",minHeight:200,
        opacity:vis?1:0,transform:vis?"translateY(0)":"translateY(30px)",
        transition:`opacity .75s ease ${i*.07}s, transform .75s ease ${i*.07}s`}}>
      <img src={img} alt={label} style={{width:"100%",height:"100%",objectFit:"cover",display:"block",transition:"transform .65s ease, filter .4s",transform:hov?"scale(1.09)":"scale(1)",filter:hov?"saturate(1.2)":"saturate(.75)"}} />
      <div style={{position:"absolute",inset:0,background:hov?"rgba(26,43,36,.5)":"rgba(26,43,36,0)",transition:"background .4s",display:"flex",alignItems:"flex-end",padding:"1rem"}}>
        <span style={{fontSize:".7rem",letterSpacing:".12em",textTransform:"uppercase",color:"white",opacity:hov?1:0,transition:"opacity .4s",fontWeight:700}}>{label}</span>
      </div>
    </div>
  );
};

const Gallery = () => (
  <section id="gallery" style={{padding:"6rem 4rem",background:"var(--dusk)"}}>
    <Reveal style={{marginBottom:"3rem"}}>
      <p style={{fontSize:".68rem",letterSpacing:".25em",textTransform:"uppercase",color:"var(--ochre)",fontWeight:700,marginBottom:".8rem"}}>Photo Journal</p>
      <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(2rem,4vw,3.2rem)",fontWeight:900,lineHeight:1.1,color:"var(--white)"}}>
        Moments from the <em style={{fontStyle:"italic",color:"var(--ochre)"}}>trails</em>
      </h2>
    </Reveal>
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gridAutoRows:"200px",gap:"1rem"}}>
      {galleryItems.map((g,i) => <GalleryItem key={i} {...g} i={i} />)}
    </div>
  </section>
);

const experiences = [
  {icon:"🌄",title:"Sunrise Treks",desc:"Start before dawn and watch the Pink City ignite in amber light from the ridgelines of Nahargarh. Worth every early alarm.",price:"From ₹799 / person"},
  {icon:"🌑",title:"Night Treks",desc:"Navigate ancient trails under the stars with headlamps and whispered folklore. Our most popular and atmospheric experience.",price:"From ₹999 / person"},
  {icon:"🏕️",title:"Camping Expeditions",desc:"Spend a night in the Aravallis with campfire meals, stargazing sessions, and the sounds of a forest breathing around you.",price:"From ₹2,499 / person"},
  {icon:"🦚",title:"Wildlife Walks",desc:"Spot leopards, peacocks, and rare birds in Jhalana Safari Park with an expert naturalist guide by your side.",price:"From ₹1,299 / person"},
  {icon:"🏛️",title:"Heritage Trails",desc:"Trek from Amer to Nahargarh along the ancient wall that connects two fortresses, collecting stories along the way.",price:"From ₹1,099 / person"},
  {icon:"🎒",title:"School & Group Treks",desc:"Custom-designed outings for schools, corporates, and families. Build bonds, break comfort zones, return stronger.",price:"Custom Pricing"},
];

const ExpCard = ({ icon, title, desc, price, i }) => {
  const [hov, setHov] = useState(false);
  const [ref, vis] = useReveal();
  return (
    <div ref={ref} onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{background:hov?"rgba(255,255,255,.1)":"rgba(255,255,255,.05)",border:"1px solid rgba(255,255,255,.1)",padding:"2.5rem 2rem",
        transition:"background .3s, transform .3s",transform:hov?"translateY(-5px)":"translateY(0)",
        opacity:vis?1:0,transitionProperty:"opacity,transform,background",
        transitionDuration:".8s,.3s,.3s",transitionDelay:`${i*.1}s,0s,0s`}}>
      <span style={{fontSize:"2.5rem",marginBottom:"1.2rem",display:"block"}}>{icon}</span>
      <h3 style={{fontFamily:"'Playfair Display',serif",fontSize:"1.3rem",fontWeight:700,color:"var(--white)",marginBottom:".8rem"}}>{title}</h3>
      <p style={{fontFamily:"'Crimson Text',serif",color:"rgba(255,255,255,.6)",lineHeight:1.75,fontSize:"1.05rem"}}>{desc}</p>
      <p style={{marginTop:"1.5rem",fontSize:".7rem",letterSpacing:".15em",textTransform:"uppercase",color:"var(--ochre)",fontWeight:700}}>{price}</p>
    </div>
  );
};

const Experiences = () => (
  <section id="experiences" style={{padding:"6rem 4rem",background:"var(--pine)"}}>
    <Reveal style={{marginBottom:"3.5rem"}}>
      <p style={{fontSize:".68rem",letterSpacing:".25em",textTransform:"uppercase",color:"var(--ochre)",fontWeight:700,marginBottom:".8rem"}}>What We Offer</p>
      <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(2rem,4vw,3.2rem)",fontWeight:900,lineHeight:1.1,color:"var(--white)"}}>
        More than a <em style={{fontStyle:"italic",color:"var(--ochre)"}}>hike</em>
      </h2>
    </Reveal>
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"1.5rem"}}>
      {experiences.map((e,i) => <ExpCard key={i} {...e} i={i} />)}
    </div>
  </section>
);

const testimonials = [
  {text:"The Nahargarh sunrise trek changed how I see Jaipur completely. Our guide knew every rock and every story. It felt like being let in on a secret the city keeps hidden.",author:"Priya Sharma — Delhi"},
  {text:"I was nervous as a first-time trekker, but the team made everything feel safe and exciting at the same time. The night trek under a full moon is something I'll never forget.",author:"Rahul Menon — Bangalore"},
  {text:"Booked the camping expedition for our college group of 10. Perfectly organized, fantastic food by the campfire, and memories that have already become legend among us.",author:"Ananya Kulkarni — Pune"},
];

const Testimonials = () => (
  <section style={{padding:"6rem 4rem",background:"var(--sand)"}}>
    <Reveal style={{marginBottom:"3rem"}}>
      <p style={{fontSize:".68rem",letterSpacing:".25em",textTransform:"uppercase",color:"var(--ochre)",fontWeight:700,marginBottom:".8rem"}}>Voices from the Tribe</p>
      <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(2rem,4vw,3.2rem)",fontWeight:900,lineHeight:1.1,color:"var(--dusk)"}}>
        What our trekkers <em style={{fontStyle:"italic",color:"var(--rust)"}}>say</em>
      </h2>
    </Reveal>
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"1.5rem"}}>
      {testimonials.map((t,i) => (
        <Reveal key={i} delay={i*.1}>
          <div style={{background:"var(--white)",padding:"2.5rem",position:"relative"}}>
            <div style={{fontFamily:"'Playfair Display',serif",fontSize:"5rem",color:"var(--ochre)",opacity:.25,position:"absolute",top:".5rem",left:"1.5rem",lineHeight:1}}>"</div>
            <div style={{color:"var(--ochre)",marginBottom:"1rem",fontSize:".9rem"}}>★★★★★</div>
            <p style={{fontFamily:"'Crimson Text',serif",fontSize:"1.08rem",fontStyle:"italic",lineHeight:1.78,color:"var(--stone)",marginBottom:"1.5rem"}}>"{t.text}"</p>
            <p style={{fontSize:".72rem",letterSpacing:".12em",textTransform:"uppercase",fontWeight:700,color:"var(--pine)"}}>{t.author}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

const CTABanner = ({ setPage }) => (
  <section style={{position:"relative",padding:"7rem 4rem",background:"url('https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1800&q=80') center/cover",textAlign:"center",overflow:"hidden"}}>
    <div style={{position:"absolute",inset:0,background:"rgba(26,43,36,.84)"}} />
    <Reveal style={{position:"relative",zIndex:1,maxWidth:700,margin:"0 auto"}}>
      <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(2rem,4.5vw,3.8rem)",fontWeight:900,color:"var(--white)",lineHeight:1.1,marginBottom:"1.2rem"}}>
        Ready to find your <em style={{fontStyle:"italic",color:"var(--ochre)"}}>tribe</em>?
      </h2>
      <p style={{fontFamily:"'Crimson Text',serif",fontSize:"1.15rem",color:"rgba(255,255,255,.72)",marginBottom:"2.5rem"}}>
        Jaipur's trails are calling. Every weekend a new journey begins — all you need to do is show up.
      </p>
      <button onClick={()=>{setPage("contact");window.scrollTo(0,0);}}
        style={{background:"var(--ochre)",color:"var(--white)",padding:".95rem 2.8rem",border:"none",fontFamily:"'Syne',sans-serif",fontSize:".82rem",letterSpacing:".15em",textTransform:"uppercase",fontWeight:700}}>
        Get in Touch
      </button>
    </Reveal>
  </section>
);

/* ══════════════════════════════════════════
   TEAM PAGE
══════════════════════════════════════════ */

const teamMembers = [
  {
    name:"Ayush Jain",
    role:"Founder & Trek Leader",
    exp:"2+ Years Experience",
    treks:"100+ Treks Led",
    bio:"Working as a hospital manager, Ayush brings exceptional planning, responsibility, and people-management skills to every trek. His passion for nature and adventure has transformed him into a dedicated trek leader who ensures every participant enjoys a safe and unforgettable experience.",
    badges:["Hospital Manager","Trek Organizer","Nature Explorer"],
    img:ayushImg,
    social:{ig:"#",fb:"#"},
    color:"var(--rust)"
  },
  {
    name:"Pawan Gurjar",
    role:"Founder & Trek Leader",
    exp:"2+ Years Experience",
    treks:"110+ Treks Led",
    bio:"An entrepreneur by profession and an explorer by heart, Pawan combines business acumen with a deep love for the outdoors. His ability to lead teams, solve challenges, and motivate people ensures every Trek Tribes adventure is both exciting and well-organized.",
    badges:["Entrepreneur","Team Leadership","Adventure Enthusiast"],
    img:pawanImg,
    social:{ig:"#",fb:"#"},
    color:"var(--pine)"
  },
  {
    name:"Prahat Singh",
    role:"Founder & Trek Leader",
    exp:"2+ Years Experience",
    treks:"50+ Treks Led",
    bio:"An engineer with a camera in hand and mountains on his mind, Prabhat is passionate about trekking, photography, and discovering hidden trails. Whether it's capturing breathtaking landscapes or leading a group through rugged terrain, he's always ready for the next adventure.",
    badges:["Engineer","Photographer","Adventure Seeker"],
    img:prabhatImg,
    social:{ig:"#",fb:"#"},
    color:"#7B5C2A"
  },
  {
    name:"Kapil",
    role:"Trek Leader",
    exp:"1+ Years Experience",
    treks:"15+ Treks Led",
    bio:"A stock market professional with a passion for the outdoors, Kapil brings analytical thinking, patience, and a calm approach to every adventure. Whether studying market trends or exploring mountain trails, he thrives on challenges and continuous learning.",
    badges:["Stock Market Analyst","Adventure Enthusiast","Strategic Thinker"],
    img:kapilImg,
    social:{ig:"#",fb:"#"},
    color:"var(--ochre)"
  },
  // {
  //   name:"Sunita Agarwal",
  //   role:"Operations & Logistics Head",
  //   exp:"7 Years Experience",
  //   treks:"All 18 Trails",
  //   bio:"The invisible backbone of The Trek Tribes. Sunita ensures every booking, safety kit, meal pack, and schedule runs like clockwork so your adventure is seamless.",
  //   badges:["Logistics Expert","Safety Manager","Trek Planner"],
  //   img:"https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=500&q=80",
  //   social:{ig:"#",fb:"#"},
  //   color:"var(--rust)"
  // },
];

const TeamCard = ({ member, i, setPage }) => {
  const [hov, setHov] = useState(false);
  const [ref, vis] = useReveal();

  return (
    <div ref={ref} onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{
        background:"var(--white)",
        gridColumn: member.featured ? "1/3" : "auto",
        opacity:vis?1:0, transform:vis?"translateY(0)":"translateY(50px)",
        transition:`opacity .85s ease ${i*.12}s, transform .85s ease ${i*.12}s`,
        boxShadow: hov ? "0 20px 60px rgba(26,43,36,.15)" : "0 4px 20px rgba(26,43,36,.06)",
        overflow:"hidden",
      }}>

      {member.featured ? (
        /* ── FEATURED CARD (horizontal) ── */
        <div style={{display:"grid",gridTemplateColumns:"420px 1fr"}}>
          <div style={{position:"relative",overflow:"hidden",minHeight:480}}>
            <img src={member.img} alt={member.name}
              style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"top",display:"block",transition:"transform .7s ease",transform:hov?"scale(1.06)":"scale(1)"}} />
            <div style={{position:"absolute",inset:0,background:"linear-gradient(to right,transparent 60%,rgba(255,255,255,.05))"}} />
            <div style={{position:"absolute",top:"1.5rem",left:"1.5rem",background:member.color,color:"var(--white)",padding:".35rem .9rem",fontSize:".62rem",letterSpacing:".2em",textTransform:"uppercase",fontWeight:700}}>
              Founder
            </div>
          </div>
          <div style={{padding:"3.5rem",display:"flex",flexDirection:"column",justifyContent:"center"}}>
            <p style={{fontSize:".68rem",letterSpacing:".25em",textTransform:"uppercase",color:member.color,fontWeight:700,marginBottom:".5rem"}}>Meet the Founder</p>
            <h3 style={{fontFamily:"'Playfair Display',serif",fontSize:"2.4rem",fontWeight:900,color:"var(--dusk)",lineHeight:1.1,marginBottom:".4rem"}}>{member.name}</h3>
            <p style={{fontSize:".78rem",letterSpacing:".12em",textTransform:"uppercase",color:"var(--stone)",marginBottom:"1.5rem",fontWeight:600}}>{member.role}</p>
            <div style={{width:60,height:2,background:member.color,marginBottom:"1.8rem"}} />
            <p style={{fontFamily:"'Crimson Text',serif",fontSize:"1.12rem",lineHeight:1.82,color:"var(--stone)",marginBottom:"2rem"}}>{member.bio}</p>
            <div style={{display:"flex",gap:".7rem",flexWrap:"wrap",marginBottom:"2rem"}}>
              {member.badges.map(b => (
                <span key={b} style={{background:`rgba(201,136,58,.1)`,border:`1px solid ${member.color}`,color:member.color,fontSize:".65rem",letterSpacing:".12em",textTransform:"uppercase",padding:".35rem .8rem",fontWeight:700}}>{b}</span>
              ))}
            </div>
            <div style={{display:"flex",gap:"2rem"}}>
              <div style={{textAlign:"center"}}>
                <span style={{fontFamily:"'Playfair Display',serif",fontSize:"1.6rem",fontWeight:900,color:member.color,display:"block"}}>{member.treks.split("+")[0]}+</span>
                <span style={{fontSize:".62rem",letterSpacing:".12em",textTransform:"uppercase",color:"var(--stone)"}}>Treks Led</span>
              </div>
              <div style={{textAlign:"center"}}>
                <span style={{fontFamily:"'Playfair Display',serif",fontSize:"1.6rem",fontWeight:900,color:member.color,display:"block"}}>{member.exp.split(" ")[0]}</span>
                <span style={{fontSize:".62rem",letterSpacing:".12em",textTransform:"uppercase",color:"var(--stone)"}}>Years Exp.</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        /* ── REGULAR CARD (vertical) ── */
        <div>
          <div style={{position:"relative",overflow:"hidden",height:280}}>
            <img src={member.img} alt={member.name}
              style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"top",display:"block",transition:"transform .7s ease",transform:hov?"scale(1.07)":"scale(1)"}} />
            <div style={{position:"absolute",inset:0,background:`linear-gradient(to top,rgba(26,43,36,.6) 0%,transparent 50%)`}} />
            <div style={{position:"absolute",bottom:"1.2rem",left:"1.2rem",right:"1.2rem",display:"flex",justifyContent:"space-between",alignItems:"flex-end"}}>
              <div>
                <div style={{fontFamily:"'Playfair Display',serif",fontSize:"1.3rem",fontWeight:900,color:"var(--white)",lineHeight:1.1}}>{member.name}</div>
                <div style={{fontSize:".65rem",letterSpacing:".12em",textTransform:"uppercase",color:"rgba(255,255,255,.7)",marginTop:".25rem"}}>{member.role}</div>
              </div>
              <div style={{width:8,height:8,borderRadius:"50%",background:member.color,boxShadow:`0 0 0 3px rgba(255,255,255,.3)`}} />
            </div>
          </div>
          <div style={{padding:"1.8rem"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:"1.2rem"}}>
              <span style={{fontSize:".68rem",color:"var(--stone)",letterSpacing:".08em"}}>{member.exp}</span>
              <span style={{fontSize:".68rem",color:member.color,fontWeight:700,letterSpacing:".08em"}}>{member.treks}</span>
            </div>
            <p style={{fontFamily:"'Crimson Text',serif",fontSize:"1rem",lineHeight:1.75,color:"var(--stone)",marginBottom:"1.4rem"}}>{member.bio}</p>
            <div style={{display:"flex",gap:".5rem",flexWrap:"wrap"}}>
              {member.badges.map(b => (
                <span key={b} style={{background:`rgba(26,43,36,.06)`,border:`1px solid rgba(26,43,36,.12)`,color:"var(--stone)",fontSize:".6rem",letterSpacing:".1em",textTransform:"uppercase",padding:".28rem .65rem",fontWeight:700}}>{b}</span>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const TeamPage = ({ setPage }) => (
  <>
    {/* Hero */}
    <section style={{minHeight:"60vh",position:"relative",display:"flex",alignItems:"flex-end",padding:"7rem 4rem 4rem",overflow:"hidden"}}>
       <div
    style={{
      position: "absolute",
      inset: 0,
      backgroundImage: `url(${teamBg})`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      animation: "slowzoom 18s ease-in-out infinite alternate"
    }}
  />
      <div style={{position:"absolute",inset:0,background:"linear-gradient(160deg,rgba(26,43,36,.82) 0%,rgba(45,74,62,.6) 100%)"}} />
      <div style={{position:"relative",zIndex:2,animation:"fadeUp 1s ease .2s both"}}>
        <span style={{display:"inline-block",background:"var(--ochre)",color:"var(--white)",fontSize:".68rem",letterSpacing:".25em",textTransform:"uppercase",padding:".4rem 1rem",marginBottom:"1.2rem",fontWeight:700}}>Our People</span>
        <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(3rem,7vw,6rem)",fontWeight:900,color:"var(--white)",lineHeight:1.0}}>
          Meet the <em style={{color:"var(--ochre)",fontStyle:"italic"}}>Tribe</em>
        </h1>
        <p style={{fontFamily:"'Crimson Text',serif",fontSize:"1.2rem",color:"rgba(255,255,255,.72)",marginTop:"1rem",maxWidth:520,lineHeight:1.75}}>
          Behind every unforgettable trek is a passionate, experienced guide who lives for the trail. These are the people who make the magic happen.
        </p>
      </div>

      {/* Floating stats */}
      <div style={{position:"absolute",bottom:"3rem",right:"4rem",zIndex:2,display:"flex",gap:"2.5rem",animation:"fadeIn 1.2s ease .5s both"}}>
        {[["4","Expert Guides"],["2+","Years Combined Exp."],["2500+","Trekkers Served"]].map(([n,l]) => (
          <div key={l} style={{textAlign:"center"}}>
            <span style={{fontFamily:"'Playfair Display',serif",fontSize:"2rem",fontWeight:900,color:"var(--ochre)",display:"block"}}>{n}</span>
            <span style={{fontSize:".62rem",letterSpacing:".15em",textTransform:"uppercase",color:"rgba(255,255,255,.5)"}}>{l}</span>
          </div>
        ))}
      </div>
    </section>

    {/* Team Grid */}
    <section style={{padding:"6rem 4rem",background:"var(--cream)"}}>
      <Reveal style={{textAlign:"center",marginBottom:"4rem"}}>
        <p style={{fontSize:".68rem",letterSpacing:".25em",textTransform:"uppercase",color:"var(--ochre)",fontWeight:700,marginBottom:".8rem"}}>The Whole Crew</p>
        <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(2rem,4vw,3rem)",fontWeight:900,lineHeight:1.1,color:"var(--dusk)"}}>
          Passionate guides, <em style={{fontStyle:"italic",color:"var(--rust)"}}>real stories</em>
        </h2>
      </Reveal>

      <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:"2rem",maxWidth:1200,margin:"0 auto"}}>
        {teamMembers.map((m,i) => <TeamCard key={i} member={m} i={i} setPage={setPage} />)}
      </div>
    </section>

    {/* Values Strip */}
    <section style={{background:"var(--pine)",padding:"5rem 4rem"}}>
      <Reveal style={{textAlign:"center",marginBottom:"3.5rem"}}>
        <p style={{fontSize:".68rem",letterSpacing:".25em",textTransform:"uppercase",color:"var(--ochre)",fontWeight:700,marginBottom:".8rem"}}>What Drives Us</p>
        <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(2rem,4vw,3rem)",fontWeight:900,color:"var(--white)",lineHeight:1.1}}>
          Our guide <em style={{fontStyle:"italic",color:"var(--ochre)"}}>philosophy</em>
        </h2>
      </Reveal>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"1.5rem"}}>
        {[
          {icon:"🛡️",title:"Safety First",desc:"Every guide is wilderness first-aid certified. We never compromise on your safety."},
          {icon:"🌿",title:"Leave No Trace",desc:"We follow strict eco principles — what we bring in, we take out. Always."},
          {icon:"🤝",title:"Small Groups",desc:"Maximum 12 trekkers per group. Real connection, real guidance."},
          {icon:"📖",title:"Living Stories",desc:"Every trail has a tale. Our guides bring history, ecology, and culture alive."},
        ].map((v,i) => (
          <Reveal key={i} delay={i*.1}>
            <div style={{border:"1px solid rgba(255,255,255,.1)",padding:"2.2rem",textAlign:"center"}}>
              <span style={{fontSize:"2.2rem",marginBottom:"1rem",display:"block"}}>{v.icon}</span>
              <h3 style={{fontFamily:"'Playfair Display',serif",fontSize:"1.15rem",fontWeight:700,color:"var(--white)",marginBottom:".7rem"}}>{v.title}</h3>
              <p style={{fontFamily:"'Crimson Text',serif",fontSize:"1rem",color:"rgba(255,255,255,.55)",lineHeight:1.72}}>{v.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>

    {/* Join Team CTA */}
    <section style={{background:"var(--sand)",padding:"5rem 4rem",textAlign:"center"}}>
      <Reveal>
        <p style={{fontSize:".68rem",letterSpacing:".25em",textTransform:"uppercase",color:"var(--ochre)",fontWeight:700,marginBottom:".8rem"}}>Work With Us</p>
        <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(2rem,4vw,3rem)",fontWeight:900,color:"var(--dusk)",lineHeight:1.1,marginBottom:"1rem"}}>
          Want to join our <em style={{fontStyle:"italic",color:"var(--rust)"}}>tribe</em>?
        </h2>
        <p style={{fontFamily:"'Crimson Text',serif",fontSize:"1.1rem",color:"var(--stone)",lineHeight:1.75,maxWidth:520,margin:"0 auto 2.5rem"}}>
          We're always looking for passionate, experienced guides who love Jaipur's wilderness as much as we do. Drop us a line.
        </p>
        <button onClick={()=>{setPage("contact");window.scrollTo(0,0);}}
          style={{background:"var(--pine)",color:"var(--white)",padding:".95rem 2.8rem",border:"none",fontFamily:"'Syne',sans-serif",fontSize:".82rem",letterSpacing:".15em",textTransform:"uppercase",fontWeight:700}}>
          Get in Touch
        </button>
      </Reveal>
    </section>

    <Footer setPage={setPage} />
  </>
);

/* ══════════════════════════════════════════
   CONTACT PAGE
══════════════════════════════════════════ */
const faqs = [
  {q:"What should I wear and bring?",a:"Comfortable trekking shoes, breathable clothing, a light backpack, water bottle (we provide refills), and sunscreen. A full packing list is sent upon booking."},
  {q:"Is prior experience needed?",a:"Not at all! We have trails for every level, from first-timers to seasoned trekkers. Just let us know and we'll match you to the right trail."},
  {q:"Are the treks safe?",a:"Absolutely. All our guides are certified in wilderness first aid, routes are risk-assessed regularly, and group sizes are kept small for maximum safety."},
  {q:"Can children join?",a:"Children aged 7+ are welcome on our Easy and Family treks. We recommend consulting us for specific age recommendations on each trail."},
  {q:"What is your cancellation policy?",a:"Full refund up to 48 hours before the trek. Within 48 hours, we offer a reschedule or 50% refund. Weather cancellations receive full refunds."},
  {q:"Do you offer private treks?",a:"Yes! Private group treks can be arranged for any number of people on any of our trails. Contact us for custom dates, routes, and pricing."},
];

const ContactPage = ({ setPage, openSeoPage }) => {
  const API_URL = "https://thetrektribes.in/api/";

  const [form, setForm] = useState({
    fname: "",
    lname: "",
    email: "",
    phone: "",
    groupsize: "",
    date: "",
    experience: "",
    message: ""
  });

  const [trekOpts, setTrekOpts] = useState([]);
  const [treksChk, setTreksChk] = useState([]);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch(API_URL + "get-trek-options.php")
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          setTrekOpts(data.data);
        }
      })
      .catch(() => {});
  }, []);

  const updateForm = (key, value) => {
    setForm(prev => ({ ...prev, [key]: value }));
  };

  const toggleTrek = item => {
    setTreksChk(prev =>
      prev.some(x => x.id === item.id)
        ? prev.filter(x => x.id !== item.id)
        : [...prev, item]
    );
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!form.fname || !form.email || !form.phone) {
      alert("Please fill First Name, Email and Phone.");
      return;
    }

    if (!/^[0-9]{10}$/.test(form.phone)) {
      alert("Please enter valid 10 digit phone number.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(API_URL + "save-enquiry.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...form,
          treks: treksChk
        })
      });

      const data = await res.json();

      if (data.status) {
        setSent(true);
        setForm({
          fname: "",
          lname: "",
          email: "",
          phone: "",
          groupsize: "",
          date: "",
          experience: "",
          message: ""
        });
        setTreksChk([]);
      } else {
        alert(data.message || "Something went wrong.");
      }
    } catch (err) {
      alert("Server error. Please try again.");
    }

    setLoading(false);
  };

  const inputStyle = {
    padding: ".95rem 1rem",
    border: "1.5px solid rgba(138,121,104,.3)",
    background: "var(--white)",
    fontFamily: "'Syne',sans-serif",
    fontSize: ".88rem",
    color: "var(--dusk)",
    width: "100%"
  };

  const labelStyle = {
    fontSize: ".68rem",
    letterSpacing: ".15em",
    textTransform: "uppercase",
    fontWeight: 700,
    color: "var(--stone)"
  };

  const inp = (label, id, type = "text", placeholder = "") => (
    <div style={{ display: "flex", flexDirection: "column", gap: ".4rem" }}>
      <label style={labelStyle}>{label}</label>
      <input
        type={type}
        value={form[id]}
        onChange={e => updateForm(id, e.target.value)}
        placeholder={placeholder}
        style={inputStyle}
        onFocus={e => e.target.style.borderColor = "var(--ochre)"}
        onBlur={e => e.target.style.borderColor = "rgba(138,121,104,.3)"}
      />
    </div>
  );

  const sel = (label, id, options) => (
    <div style={{ display: "flex", flexDirection: "column", gap: ".4rem" }}>
      <label style={labelStyle}>{label}</label>
      <select
        value={form[id]}
        onChange={e => updateForm(id, e.target.value)}
        style={{
          ...inputStyle,
          appearance: "none"
        }}
        onFocus={e => e.target.style.borderColor = "var(--ochre)"}
        onBlur={e => e.target.style.borderColor = "rgba(138,121,104,.3)"}
      >
        <option value="">Select</option>
        {options.map(o => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>
    </div>
  );

  return (
    <>
      <SEO />

      <section style={{
        minHeight: "55vh",
        position: "relative",
        display: "flex",
        alignItems: "flex-end",
        padding: "7rem 4rem 4rem",
        overflow: "hidden"
      }}>
        <div style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${teamBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          animation: "slowzoom 18s ease-in-out infinite alternate"
        }} />

        <div style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(160deg,rgba(26,43,36,.86),rgba(26,43,36,.72))"
        }} />

        <div style={{
          position: "relative",
          zIndex: 2,
          animation: "fadeUp 1s ease .2s both"
        }}>
          <span style={{
            display: "inline-block",
            background: "var(--ochre)",
            color: "var(--white)",
            fontSize: ".68rem",
            letterSpacing: ".25em",
            textTransform: "uppercase",
            padding: ".4rem 1rem",
            marginBottom: "1.2rem",
            fontWeight: 700
          }}>
            Contact Us
          </span>

          <h1 style={{
            fontFamily: "'Playfair Display',serif",
            fontSize: "clamp(3rem,7vw,6rem)",
            fontWeight: 900,
            color: "var(--white)",
            lineHeight: 1
          }}>
            Plan Your <em style={{ color: "var(--ochre)", fontStyle: "italic" }}>Adventure</em>
          </h1>

          <p style={{
            fontFamily: "'Crimson Text',serif",
            fontSize: "1.2rem",
            color: "rgba(255,255,255,.72)",
            marginTop: "1rem",
            maxWidth: 560,
            lineHeight: 1.75
          }}>
            Submit your enquiry and our team will help you join the next trek, trail or outdoor experience.
          </p>
        </div>
      </section>

      <section style={{
        padding: "6rem 4rem",
        background: "var(--cream)"
      }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: "1.15fr .85fr",
          gap: "3rem",
          maxWidth: 1200,
          margin: "0 auto"
        }}>

          <Reveal>
            <form onSubmit={handleSubmit} style={{
              background: "var(--white)",
              padding: "3rem",
              boxShadow: "0 12px 40px rgba(26,43,36,.08)"
            }}>
              <p style={{
                fontSize: ".68rem",
                letterSpacing: ".25em",
                textTransform: "uppercase",
                color: "var(--ochre)",
                fontWeight: 700,
                marginBottom: ".8rem"
              }}>
                Enquiry Form
              </p>

              <h2 style={{
                fontFamily: "'Playfair Display',serif",
                fontSize: "2.6rem",
                fontWeight: 900,
                color: "var(--dusk)",
                marginBottom: "2rem",
                lineHeight: 1.1
              }}>
                Join The Trek Tribes
              </h2>

              {sent && (
                <div style={{
                  background: "#dcfce7",
                  color: "#166534",
                  padding: "1rem",
                  marginBottom: "1.5rem",
                  fontWeight: 700,
                  border: "1px solid #86efac"
                }}>
                  Enquiry submitted successfully. Our team will contact you soon.
                </div>
              )}

              <div style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "1.2rem",
                marginBottom: "1.2rem"
              }}>
                {inp("First Name *", "fname", "text", "Your first name")}
                {inp("Last Name", "lname", "text", "Your last name")}
                {inp("Email *", "email", "email", "you@example.com")}
                {inp("Phone *", "phone", "text", "10 digit mobile")}
                {sel("Group Size", "groupsize", ["Solo", "2-4 People", "5-8 People", "9-12 People", "12+ People"])}
                {inp("Preferred Date", "date", "date")}
                {sel("Experience Level", "experience", ["First Time", "Beginner", "Intermediate", "Experienced"])}
              </div>

              <div style={{ marginBottom: "1.5rem" }}>
                <label style={{
                  ...labelStyle,
                  display: "block",
                  marginBottom: ".7rem"
                }}>
                  Interested Treks
                </label>

                <div style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: ".8rem"
                }}>
                  {trekOpts.length > 0 ? trekOpts.map(item => {
                    const active = treksChk.some(x => x.id === item.id);

                    return (
                      <button
                        type="button"
                        key={item.id}
                        onClick={() => toggleTrek(item)}
                        style={{
                          padding: ".85rem 1rem",
                          background: active ? "var(--ochre)" : "var(--cream)",
                          color: active ? "var(--white)" : "var(--dusk)",
                          border: "1px solid rgba(138,121,104,.25)",
                          textAlign: "left",
                          fontFamily: "'Syne',sans-serif",
                          fontSize: ".85rem",
                          fontWeight: 700
                        }}
                      >
                        {item.label}
                      </button>
                    );
                  }) : (
                    <p style={{
                      color: "var(--stone)",
                      fontFamily: "'Crimson Text',serif",
                      gridColumn: "1 / 3"
                    }}>
                      Trek options loading...
                    </p>
                  )}
                </div>
              </div>

              <div style={{
                display: "flex",
                flexDirection: "column",
                gap: ".4rem",
                marginBottom: "1.8rem"
              }}>
                <label style={labelStyle}>Message</label>
                <textarea
                  value={form.message}
                  onChange={e => updateForm("message", e.target.value)}
                  placeholder="Tell us anything important..."
                  rows="5"
                  style={{
                    ...inputStyle,
                    resize: "vertical"
                  }}
                  onFocus={e => e.target.style.borderColor = "var(--ochre)"}
                  onBlur={e => e.target.style.borderColor = "rgba(138,121,104,.3)"}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  background: loading ? "var(--stone)" : "var(--ochre)",
                  color: "var(--white)",
                  padding: ".95rem 2.8rem",
                  border: "none",
                  fontFamily: "'Syne',sans-serif",
                  fontSize: ".82rem",
                  letterSpacing: ".15em",
                  textTransform: "uppercase",
                  fontWeight: 700,
                  width: "100%"
                }}
              >
                {loading ? "Submitting..." : "Submit Enquiry"}
              </button>
            </form>
          </Reveal>

          <Reveal delay={0.12}>
            <div style={{
              background: "var(--pine)",
              padding: "3rem",
              color: "var(--white)",
              minHeight: "100%"
            }}>
              <p style={{
                fontSize: ".68rem",
                letterSpacing: ".25em",
                textTransform: "uppercase",
                color: "var(--ochre)",
                fontWeight: 700,
                marginBottom: ".8rem"
              }}>
                Contact Details
              </p>

              <h3 style={{
                fontFamily: "'Playfair Display',serif",
                fontSize: "2rem",
                fontWeight: 900,
                marginBottom: "1.5rem"
              }}>
                The Trek Tribes
              </h3>

              <p style={{
                fontFamily: "'Crimson Text',serif",
                fontSize: "1.1rem",
                lineHeight: 1.8,
                color: "rgba(255,255,255,.7)",
                marginBottom: "2rem"
              }}>
                Jaipur based trekking community organizing guided weekend treks, sunrise hikes and Aravalli adventures.
              </p>

              <div style={{ display: "grid", gap: "1rem", marginBottom: "2.2rem" }}>
                <p>📞 +91 94614 41052</p>
                <p>✉️ tribestrek@gmail.com</p>
                <p>📍 Ramnagar Extension, Sodala, Jaipur</p>
                <p>📸 Instagram: trek_tribes_</p>
              </div>

              <div style={{
                background: "rgba(255,255,255,.07)",
                padding: "1.5rem",
                border: "1px solid rgba(255,255,255,.1)"
              }}>
                <h4 style={{
                  fontFamily: "'Playfair Display',serif",
                  fontSize: "1.3rem",
                  marginBottom: ".8rem",
                  color: "var(--ochre)"
                }}>
                  Popular Searches
                </h4>

                <div style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: ".6rem"
                }}>
                  {[
  { text: "treks", slug: "treks" },
  { text: "trek in jaipur", slug: "trek-in-jaipur" },
  { text: "best mountain biking trails", slug: "best-mountain-biking-trails" }
].map(item => (
  <button
    key={item.slug}
    type="button"
    onClick={() => openSeoPage(item.slug)}
    style={{
      background: "transparent",
      border: "1px solid rgba(255,255,255,.25)",
      color: "rgba(255,255,255,.75)",
      padding: ".45rem .75rem",
      fontSize: ".72rem",
      letterSpacing: ".08em",
      textTransform: "uppercase",
      fontFamily: "'Syne',sans-serif"
    }}
  >
    {item.text}
  </button>
))}
                </div>
              </div>
            </div>
          </Reveal>

        </div>
      </section>

      <Footer setPage={setPage} />
    </>
  );
};
/* ─── FOOTER ─── */
const Footer = ({ setPage }) => (
  <>
    <footer style={{background:"var(--dusk)",padding:"4rem",display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:"3rem"}}>
      <div>
        <button onClick={()=>{setPage("home");window.scrollTo(0,0);}} style={{background:"none",border:"none",fontFamily:"'Playfair Display',serif",fontSize:"1.5rem",fontWeight:900,color:"var(--white)",display:"block",marginBottom:"1rem"}}>
          The Trek<span style={{color:"var(--ochre)"}}>Tribes</span>
        </button>
        <p style={{fontFamily:"'Crimson Text',serif",color:"rgba(255,255,255,.45)",lineHeight:1.75,fontSize:"1rem"}}>
          Jaipur's most intimate trekking collective. We take you off the tourist trail and into the soul of Rajasthan.
        </p>
      </div>
      {[
        {h:"Treks",links:["Nahargarh Ridge","Monsoon Forest Walk","Night Trek","Fort to Fort","Stargazing"]},
        {h:"Company",links:["About Us","Our Guides","Gallery","Team","Contact"]},
        {h:"Connect",links:["Instagram","Facebook","WhatsApp","tribestrek@gmail.com"]},
      ].map(col => (
        <div key={col.h}>
          <h4 style={{fontSize:".68rem",letterSpacing:".2em",textTransform:"uppercase",color:"var(--ochre)",marginBottom:"1.2rem"}}>{col.h}</h4>
          <ul style={{listStyle:"none"}}>
            {col.links.map(l => <li key={l} style={{marginBottom:".6rem"}}><span style={{color:"rgba(255,255,255,.5)",fontSize:".85rem"}}>{l}</span></li>)}
          </ul>
        </div>
      ))}
    </footer>
    <div
  style={{
    background: "var(--dusk)",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    padding: "1.5rem 2rem",
    textAlign: "center",
  }}
>
  <p
    style={{
      color: "rgba(255,255,255,0.55)",
      fontSize: ".9rem",
      marginBottom: ".5rem",
    }}
  >
    © 2026 The Trek Tribes • India
  </p>

  <p
    style={{
      color: "rgba(255,255,255,0.35)",
      fontSize: ".8rem",
      margin: 0,
      fontStyle: "italic",
    }}
  >
    "Not all those who wander are lost."
  </p>
</div>
  </>
);

/* ─── HOME PAGE ─── */
const HomePage = ({ setPage }) => (
  <>
    <Hero setPage={setPage} />
    <Stats />
    <About setPage={setPage} />
    <Treks setPage={setPage} />
    <Gallery />
    <Experiences />
    <Testimonials />
    <CTABanner setPage={setPage} />
    <Footer setPage={setPage} />
  </>
);


const BlogSEOPage = ({ pageData, setPage, openSeoPage }) => (
  <>
    <SEO pageData={pageData} />

    <section
      style={{
        padding: "8rem 4rem 4rem",
        background: "var(--pine)",
        color: "var(--white)"
      }}
    >
      <span
        style={{
          display: "inline-block",
          background: "var(--ochre)",
          color: "var(--white)",
          fontSize: ".68rem",
          letterSpacing: ".25em",
          textTransform: "uppercase",
          padding: ".4rem 1rem",
          marginBottom: "1.2rem",
          fontWeight: 700
        }}
      >
        {pageData.badge}
      </span>

      <h1
        style={{
          fontFamily: "'Playfair Display',serif",
          fontSize: "clamp(2.7rem,6vw,5.4rem)",
          fontWeight: 900,
          lineHeight: 1.05,
          maxWidth: 980
        }}
      >
        {pageData.heading}
      </h1>

      <p
        style={{
          fontFamily: "'Crimson Text',serif",
          fontSize: "1.22rem",
          color: "rgba(255,255,255,.75)",
          lineHeight: 1.8,
          maxWidth: 820,
          marginTop: "1.2rem"
        }}
      >
        {pageData.desc}
      </p>
    </section>

    <section style={{ padding: "5rem 4rem", background: "var(--cream)" }}>
      <article style={{ maxWidth: 980, margin: "0 auto" }}>
        <p
          style={{
            fontFamily: "'Crimson Text',serif",
            fontSize: "1.25rem",
            lineHeight: 1.9,
            color: "var(--stone)",
            marginBottom: "2rem"
          }}
        >
          {pageData.intro}
        </p>

        {pageData.sections.map((section, index) => (
          <div key={index} style={{ marginTop: "2.8rem" }}>
            <h2
              style={{
                fontFamily: "'Playfair Display',serif",
                fontSize: "2rem",
                color: "var(--dusk)",
                marginBottom: "1rem",
                lineHeight: 1.2
              }}
            >
              {section.h}
            </h2>

            {section.p.map((para, i) => (
              <p
                key={i}
                style={{
                  fontFamily: "'Crimson Text',serif",
                  fontSize: "1.13rem",
                  lineHeight: 1.9,
                  color: "var(--stone)",
                  marginBottom: "1rem"
                }}
              >
                {para}
              </p>
            ))}
          </div>
        ))}

        <div
          style={{
            marginTop: "3.5rem",
            background: "var(--white)",
            padding: "2.5rem",
            borderLeft: "5px solid var(--ochre)"
          }}
        >
          <h2
            style={{
              fontFamily: "'Playfair Display',serif",
              fontSize: "2rem",
              color: "var(--dusk)",
              marginBottom: "1rem"
            }}
          >
            Book Your Next Trek with The Trek Tribes
          </h2>

          <p
            style={{
              fontFamily: "'Crimson Text',serif",
              fontSize: "1.12rem",
              lineHeight: 1.8,
              color: "var(--stone)"
            }}
          >
            Join Jaipur's trekking community for guided Saturday and Sunday morning treks in the Aravalli Hills.
            Whether you are a beginner or a regular trekker, The Trek Tribes helps you explore Jaipur's natural side safely.
          </p>

          <button
            onClick={() => {
              setPage("contact");
              window.history.pushState({}, "", "/");
              window.scrollTo(0, 0);
            }}
            style={{
              marginTop: "1.5rem",
              background: "var(--ochre)",
              color: "var(--white)",
              padding: ".95rem 2.5rem",
              border: "none",
              fontFamily: "'Syne',sans-serif",
              fontSize: ".82rem",
              letterSpacing: ".15em",
              textTransform: "uppercase",
              fontWeight: 700
            }}
          >
            Enquire Now
          </button>
        </div>

        <div style={{ marginTop: "3.5rem" }}>
          <h2
            style={{
              fontFamily: "'Playfair Display',serif",
              fontSize: "2rem",
              color: "var(--dusk)",
              marginBottom: "1.2rem"
            }}
          >
            Frequently Asked Questions
          </h2>

          {pageData.faqs.map((item, index) => (
            <div
              key={index}
              style={{
                background: "var(--white)",
                padding: "1.3rem 1.5rem",
                marginBottom: ".8rem",
                border: "1px solid rgba(26,43,36,.08)"
              }}
            >
              <h3
                style={{
                  fontFamily: "'Syne',sans-serif",
                  fontSize: "1rem",
                  color: "var(--pine)",
                  marginBottom: ".5rem"
                }}
              >
                {item.q}
              </h3>
              <p
                style={{
                  fontFamily: "'Crimson Text',serif",
                  fontSize: "1.05rem",
                  lineHeight: 1.75,
                  color: "var(--stone)"
                }}
              >
                {item.a}
              </p>
            </div>
          ))}
        </div>

        <div style={{ marginTop: "3.5rem" }}>
          <h2
            style={{
              fontFamily: "'Playfair Display',serif",
              fontSize: "1.8rem",
              color: "var(--dusk)",
              marginBottom: "1rem"
            }}
          >
            More Jaipur Trekking Guides
          </h2>

          <div style={{ display: "flex", flexWrap: "wrap", gap: ".8rem" }}>
            {seoPages
              .filter(item => item.slug !== pageData.slug)
              .map(item => (
                <button
                  key={item.slug}
                  onClick={() => openSeoPage(item.slug)}
                  style={{
                    background: "var(--sand)",
                    border: "1px solid rgba(26,43,36,.12)",
                    color: "var(--pine)",
                    padding: ".75rem 1rem",
                    fontFamily: "'Syne',sans-serif",
                    fontSize: ".78rem",
                    letterSpacing: ".08em",
                    textTransform: "uppercase",
                    fontWeight: 700
                  }}
                >
                  {item.heading}
                </button>
              ))}
          </div>
        </div>
      </article>
    </section>

    <Footer setPage={setPage} />
  </>
);

/* ─── APP ROOT ─── */
export default function App() {
  const getInitialRoute = () => {
    const slug = window.location.pathname.replace(/^\/+|\/+$/g, "");
    const found = seoPages.find(item => item.slug === slug);

    if (found) {
      return { activePage: "blog", activeSeoPage: found };
    }

    return { activePage: "home", activeSeoPage: null };
  };

  const initialRoute = getInitialRoute();

  const [page, setPageState] = useState(initialRoute.activePage);
  const [activeSeoPage, setActiveSeoPage] = useState(initialRoute.activeSeoPage);

  const setPage = nextPage => {
    setActiveSeoPage(null);
    setPageState(nextPage);

    if (window.location.pathname !== "/") {
      window.history.pushState({}, "", "/");
    }

    window.scrollTo(0, 0);
  };

  const openSeoPage = slug => {
    const found = seoPages.find(item => item.slug === slug);
    if (!found) return;

    setActiveSeoPage(found);
    setPageState("blog");
    window.history.pushState({}, "", `/${slug}`);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const handlePopState = () => {
      const route = getInitialRoute();
      setPageState(route.activePage);
      setActiveSeoPage(route.activeSeoPage);
      window.scrollTo(0, 0);
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <HelmetProvider>
      {!activeSeoPage && <SEO />}

      <FontLoader />
      <GlobalStyles />
      <Cursor />
      <Nav page={page} setPage={setPage} />

      <main>
        {page === "blog" && activeSeoPage && (
          <BlogSEOPage
            pageData={activeSeoPage}
            setPage={setPage}
            openSeoPage={openSeoPage}
          />
        )}

        {page === "home" && <HomePage setPage={setPage} />}
        {page === "team" && <TeamPage setPage={setPage} />}
        {page === "contact" && (
  <ContactPage 
    setPage={setPage} 
    openSeoPage={openSeoPage} 
  />
)}
      </main>
    </HelmetProvider>
  );
}
